var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.document ? _c('timeline-card', {
    attrs: {
      "id": _vm.document ? _vm.document.title : 'document',
      "loading": _vm.isLoading,
      "title": _vm.title
    },
    scopedSlots: _vm._u([{
      key: "menu",
      fn: function fn() {
        return [_c('v-chip', {
          staticClass: "mr-1",
          attrs: {
            "small": "",
            "color": _vm.colorByStatus.get(_vm.document.status)
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("sign.DigitalSignatureRequestStatus.".concat(_vm.document.status))) + " ")])];
      },
      proxy: true
    }], null, false, 644046038)
  }, [_c('iframe', {
    staticClass: "pdf",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "title": "pdf",
      "src": _vm.document.documents[0],
      "width": "100%",
      "height": "450px"
    }
  })]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }